import { Link, LinkProps, LinkSize, LinkStyle } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import React, { FC } from 'react';
import { token } from '@atlaskit/tokens';

const AnimatedLink: FC<LinkProps> = (props) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    props.onClick?.(e);

    window.open(props.link, props.target ?? '_blank');
  };

  return (
    <span css={linkContainerStyles}>
      <Link
        {...props}
        size={props.size ?? LinkSize.MEDIUM}
        style={props.style ?? LinkStyle.SEMIBOLD}
        icon="arrow-right"
        onClick={handleClick}
      />
    </span>
  );
};

const linkContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.050'),

  '& a:hover': {
    textDecoration: 'none',
  },

  '& a:hover span:last-of-type': {
    transform: 'translateX(4px)',
  },
});

export default AnimatedLink;
